module.exports = __webpack_public_path__ + "img/PA.e9d3d6f0.svg";